// Hook wrapping navigator.geolocation.watchPosition with proper lifecycle.
// The previous implementation in trackContent.js started a watcher but never
// cleared it on unmount, leaking the GPS callback whenever the driver
// navigated away or the component remounted.

import { useEffect, useRef, useState } from "react";

export function useWatchPosition(enabled) {
  const [currentPos, setCurrentPos] = useState([0, 0]);
  const [currentPosInit, setCurrentPosInit] = useState(false);
  const [locationApiError, setLocationApiError] = useState(null);
  const watchId = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      setLocationApiError(-1);
      return undefined;
    }

    watchId.current = navigator.geolocation.watchPosition(
      (pos) => {
        setCurrentPos([pos.coords.latitude, pos.coords.longitude]);
        setCurrentPosInit(true);
        setLocationApiError(null);
      },
      (err) => {
        setLocationApiError(err.code);
      },
      { enableHighAccuracy: true }
    );

    return () => {
      if (watchId.current != null) {
        navigator.geolocation.clearWatch(watchId.current);
        watchId.current = null;
      }
    };
  }, [enabled]);

  return { currentPos, currentPosInit, locationApiError };
}
